import React from "react";

export const HazeIcon = () => (
    <svg
        tabIndex={-1}
        focusable="false"
        className="svg-icon icon-weather"
        width="80px"
        height="80px"
        fill="none"
        viewBox="0 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g className="weather-fill" id="21" fillRule="nonzero" fill="#3F4447">
                <g transform="translate(4.000000, 23.000000)">
                    <path
                        d="M4.882 47.756h47.512a1.55 1.55 0 100-3.099H4.882a1.55 1.55 0 100 3.099zM57.558 47.756h17.559a1.55 1.55 0 000-3.099H57.558a1.55 1.55 0 100 3.099zM11.079 58.084h57.84a1.55 1.55 0 000-3.098h-57.84a1.55 1.55 0 000 3.098zM4.882 27.098h63.005a1.55 1.55 0 000-3.098H4.882a1.55 1.55 0 000 3.098zM23.473 37.427h51.643a1.55 1.55 0 100-3.099H23.473a1.55 1.55 0 000 3.099z"
                        fill="#3F4447"
                    />
                </g>
            </g>
        </g>
    </svg>
);
